module.exports = __webpack_public_path__ + "media/application/images/favicon-3b352c42a4f46d15429c1881f719f385.png";